import axios from 'axios';
export default {
    namespaced : true,
    actions : {
        fileUpload(context,value){
            console.log(value);
            axios.post('/upload',value)
            .then((response) =>{
                console.log(`传送成功${response}`)
            })
            .catch((error) => {
                console.log(error);
            })
        }
    }
}


// WEBPACK FOOTER //
// ./src/vuex/Employ.js